(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    var Menu = function Menu() {
        this.initializeEvents();
    };
    Menu.prototype.initializeEvents = function initializeEvents () {
        this.animateShortMenu();
        this.animateMainMenu();
        var self = this;
        setTimeout(function () {
            self.openToolboxNavigation();
        }, 1000);
    };

    Menu.prototype.animateShortMenu = function animateShortMenu () {
        var shortMenu = document.querySelector('#short-menu ul');
        var codeMenu = '<div class="ago-bg-item-menu"></div>';

        shortMenu.insertAdjacentHTML("beforebegin", codeMenu);

        var menuItems = shortMenu.querySelectorAll('li:not(:last-child)');
        var blackBackground = document.querySelector('nav .ago-bg-item-menu');

        menuItems.forEach(function (list) {
            list.addEventListener('mouseover', function () {
                blackBackground.classList.add('active');
                blackBackground.style.left = list.offsetLeft + 'px';
                blackBackground.style.width = list.offsetWidth + 'px';
            });
            list.addEventListener('mouseout', function () {
                blackBackground.classList.remove('active');
            });
        });
    };
    Menu.prototype.animateMainMenu = function animateMainMenu () {
        var mainMenu = document.querySelector('#main-burger-menu');
        if (mainMenu) {
            var menuToggle = mainMenu.querySelector('.elementor-menu-toggle');
            if (menuToggle) {
                menuToggle.innerHTML += "<div class=\"burger__container\">" +
                    "            <input id=\"toggle\" type=\"checkbox\"/>" +
                    "            <label for=\"toggle\" class=\"burger\">" +
                    "                <div class=\"burger__top-bar\"></div>" +
                    "                <div class=\"burger__middle-bar\"></div>" +
                    "                <div class=\"burger__bottom-bar\"></div>" +
                    "            </label>" +
                    "        </div>";
            }
        }
        var burger = document.querySelector('.burger');
        var megamenu = mainMenu.querySelector('.elementor-nav-menu__container');
        burger.addEventListener("click", function (event) {
            var classHidden = 'is-hidden';
            var classOpened = 'is-open';
            if (megamenu.classList.contains(classHidden)) {
                setTimeout(function() {
                    mainMenu.classList.remove(classOpened);
                }, 300);
                megamenu.classList.remove(classHidden);
            } else {
                mainMenu.classList.add(classOpened);
                megamenu.classList.add(classHidden);
            }
        });
    };

    Menu.prototype.openToolboxNavigation = function openToolboxNavigation () {
        var toolboxTreeFirstItem = document.querySelector('.jaofiletree > li > a');
        if (toolboxTreeFirstItem) {
            toolboxTreeFirstItem.click();
        }
    };

    document.addEventListener("DOMContentLoaded", function() {
        setTimeout(function () {
            var burgerToggle = document.getElementById('toggle');
            if(burgerToggle) {
                burgerToggle.checked = false;
            }
        }, 100);
    });

    var Form = function Form() {
        this.initializeEvents();
    };

    Form.prototype.initializeEvents = function initializeEvents () {
        // Add select2 JS to department selectbox
        var selectDepartment = document.querySelector('#form-field-department');
        if(selectDepartment) {
            jQuery(document).ready(function($) {
                $('#form-field-department').select2();
            });
        }
    };

    document.addEventListener('DOMContentLoaded', function () {
        new Menu();
        new Form();
    });

}));
//# sourceMappingURL=hello-elementor-child.min.js.map
